// TODO: refactor slot imports
import {SystemPopup, SystemPopupPopupID} from '@gongxigames/framework/slot/types';

export type SystemPopupsEvents = {
    'General.Popups.Add': SystemPopup;
    'General.Popups.Remove': SystemPopup | SystemPopupPopupID;
    'General.Popups.RemoveAll': void;
    'General.Popups.AllPopupsHidden': void;
};
